// extracted by mini-css-extract-plugin
export default {"ul":"CardSelected_ul__I0wfC","close":"CardSelected_close__wN2Tu"};